import { forwardRef, type Ref, type SVGProps } from "react";
const IconSendOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.5 2.56a2 2 0 0 0-1.99-.53L3.38 8.93a2 2 0 0 0-.56 3.58l9.2 6.13.81.54.54.92 5.22 8.95a1.98 1.98 0 0 0 1.72 1 2 2 0 0 0 .22-.02 2 2 0 0 0 1.7-1.38l7.73-24.08a2 2 0 0 0-.47-2zm-9.18 25.5a.01.01 0 0 0 0-.02l-5.49-9.4 5.46-5.45a1 1 0 0 0-1.42-1.42l-5.42 5.42-9.52-6.34 24.13-6.89z" />
  </svg>
);
const ForwardRef = forwardRef(IconSendOutlineSVG);
ForwardRef.displayName = "IconSendOutline";
export { ForwardRef as IconSendOutline };
